import { getCountry, getLanguage } from './locale-helper';

export const parseContentVariables = (
  pagePath: string | null,
  rawContent?: string,
  inputLocale?: SupportedLocale
): string | null => {
  if (!rawContent) {
    return null;
  }

  let localeCode: SupportedLocale | undefined = inputLocale;
  let path: string | null = pagePath;

  // If using contentful default en locale code, fall back to en-US
  if (!localeCode || localeCode === 'en') {
    localeCode = 'en-US';
  }

  if (!path) {
    path = '';
  }

  const langCode = getLanguage(localeCode);
  const countryCode = getCountry(localeCode);
  const locale = `${countryCode}/${langCode}`;

  return rawContent
    .replaceAll('{locale}', locale)
    .replaceAll('{locale_code}', localeCode)
    .replaceAll('{country_code}', countryCode)
    .replaceAll('{lang_code}', langCode)
    .replaceAll('{page_path}', path);
};
